module.exports = __webpack_public_path__ + "static/media/dr-hooman.b3deb032.jpg";